import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "contentContainer centerContent" }
const _hoisted_3 = { class: "contentColumn" }
const _hoisted_4 = { class: "left-section" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "center-section" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "right-section" }
const _hoisted_9 = { class: "loginComp" }
const _hoisted_10 = { class: "login-head" }
const _hoisted_11 = { class: "login-elem" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "login-label" }
const _hoisted_15 = { class: "inputPanel" }
const _hoisted_16 = { class: "button-and-recover-panel" }
const _hoisted_17 = { class: "button-box" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "loginError"
}
const _hoisted_21 = { class: "pointer footer-elem" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "login-label-password" }
const _hoisted_24 = { class: "autorization-elem-password" }
const _hoisted_25 = { class: "login-label-password-message" }
const _hoisted_26 = { class: "button-and-recover-panel" }
const _hoisted_27 = { class: "button-box" }
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "loginError"
}
const _hoisted_31 = { class: "footer-elem-password" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "login-label-password" }
const _hoisted_34 = { class: "autorization-elem-password" }
const _hoisted_35 = { class: "recover-message-box" }
const _hoisted_36 = { class: "login-label-recover-password-message" }
const _hoisted_37 = { class: "login-label-recover-password-message" }
const _hoisted_38 = {
  class: "button-box",
  style: {"margin-top":"8px"}
}
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 1,
  class: "loginError"
}
const _hoisted_42 = { class: "footer-elem-password" }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = { class: "login-label-access" }
const _hoisted_45 = { class: "autorization-elem-password" }
const _hoisted_46 = { class: "recover-message-box" }
const _hoisted_47 = { class: "login-label-recover-password-message" }
const _hoisted_48 = { class: "button-box" }
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "loginError"
}
const _hoisted_52 = { class: "footer-elem-password" }
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { class: "login-label-access" }
const _hoisted_55 = { class: "autorization-elem-password" }
const _hoisted_56 = { class: "login-label-recover-password-message" }
const _hoisted_57 = { class: "button-box" }
const _hoisted_58 = ["src"]
const _hoisted_59 = ["src", "disabled"]
const _hoisted_60 = {
  key: 1,
  class: "loginLeftPanelElement loginError"
}
const _hoisted_61 = { class: "footer-elem-password" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LangDropdown = _resolveComponent("LangDropdown")!
  const _component_LoginInput = _resolveComponent("LoginInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_LoginButtonLink = _resolveComponent("LoginButtonLink")!
  const _component_AppTextarea = _resolveComponent("AppTextarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "background-layer" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: $setup.currentMainMostaLabelLangIcon,
            class: "back-login-image"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: $setup.iconLoginCentralLine,
            width: "16",
            height: "16",
            class: "central-login-line-image"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_LangDropdown, {
                  languages: $setup.languages,
                  "current-language": $setup.currentLanguage,
                  onLanguageChange: $setup.selectLanguage
                }, null, 8, ["languages", "current-language", "onLanguageChange"])
              ]),
              _createElementVNode("img", {
                src: $setup.currentMostaLabelLangIcon,
                width: "16",
                height: "16",
                class: "mosta-label"
              }, null, 8, _hoisted_12)
            ]),
            ($setup.loginPage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Login.EnterMessage')), 1),
                  _createElementVNode("form", {
                    class: "autorizationElem",
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.LoginInside && $setup.LoginInside(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_LoginInput, {
                        modelValue: $setup.login.Mail,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.login.Mail) = $event)),
                        error: $setup.loginError,
                        onClearError: $setup.clearLoginError
                      }, null, 8, ["modelValue", "error", "onClearError"]),
                      _createVNode(_component_PasswordInput, {
                        modelValue: $setup.login.PassWord,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.login.PassWord) = $event)),
                        error: $setup.loginError,
                        onClearError: $setup.clearLoginError
                      }, null, 8, ["modelValue", "error", "onClearError"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: $setup.iconButtonLeftLine,
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_18),
                        _createVNode(_component_AppButton, {
                          label: _ctx.$t('Login.Login'),
                          disabled: $setup.isLoginButtonDisabled,
                          width: "136px",
                          type: "primary"
                        }, null, 8, ["label", "disabled"]),
                        _createElementVNode("img", {
                          src: $setup.iconButtonRightLine,
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_19)
                      ]),
                      _createElementVNode("div", {
                        class: "loginClickableText",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.showPasswordRecover && $setup.showPasswordRecover(...args)))
                      }, _toDisplayString(_ctx.$t('Login.ForgotPassword')), 1)
                    ]),
                    ($setup.isLoginLoading)
                      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.loginErrorText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.statusCode != 500 ? _ctx.$t('Login.LoginError') : _ctx.$t('Login.ServerError')), 1))
                      : _createCommentVNode("", true)
                  ], 32),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_LoginButtonLink, {
                      label: _ctx.$t('Login.Unsigned'),
                      "icon-src": $setup.iconUnsign,
                      "tooltip-text": _ctx.$t('Login.UnsignedHintMessage'),
                      "show-tooltip-on-hover": true,
                      onMouseenter: _cache[4] || (_cache[4] = ($event: any) => ($setup.showHint = true)),
                      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($setup.showHint = false))
                    }, null, 8, ["label", "icon-src", "tooltip-text"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.passwordRecover)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('Login.PasswordRecovering')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('Login.InputUsedEmail')), 1),
                    _createVNode(_component_LoginInput, {
                      modelValue: $setup.login.Mail,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.login.Mail) = $event)),
                      error: $setup.loginError,
                      onClearError: $setup.clearLoginError
                    }, null, 8, ["modelValue", "error", "onClearError"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("img", {
                          src: $setup.iconButtonLeftLine,
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_28),
                        _createVNode(_component_AppButton, {
                          label: _ctx.$t('Login.PasswordRecoveringButton'),
                          disabled: $setup.isRecoverButtonDisabled,
                          onClick: $setup.recoverPasswordInside,
                          width: "175px",
                          type: "primary"
                        }, null, 8, ["label", "disabled", "onClick"]),
                        _createElementVNode("img", {
                          src: $setup.iconButtonRightLine,
                          width: "16",
                          height: "16",
                          class: "button-line"
                        }, null, 8, _hoisted_29)
                      ]),
                      _createElementVNode("div", {
                        class: "loginClickableText",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.showAccessRecover && $setup.showAccessRecover(...args)))
                      }, _toDisplayString(_ctx.$t('Login.AuthorizationProblem')), 1)
                    ]),
                    ($setup.isLoginLoading)
                      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.loginErrorText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($setup.statusCode != 500 ? _ctx.$t('Login.UserNotFoundError') : _ctx.$t('Login.ServerError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: $setup.showLoginPage,
                      type: "link",
                      width: "111px"
                    }, null, 8, ["label", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.passwordRecoverResult)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('Login.PasswordRecovering')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Login.PasswordSentToMail')), 1),
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('Login.RepeatResponsePasswordMessage')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("img", {
                        src: $setup.iconButtonLeftLine,
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_39),
                      _createVNode(_component_AppButton, {
                        label: _ctx.$t('Login.SendAgain'),
                        onClick: $setup.recoverPasswordInside,
                        style: {"width":"153px !important"},
                        disabled: $setup.isLoginLoading,
                        type: "primary"
                      }, null, 8, ["label", "onClick", "disabled"]),
                      _createElementVNode("img", {
                        src: $setup.iconButtonRightLine,
                        width: "16",
                        height: "16",
                        class: "button-line",
                        type: "primary"
                      }, null, 8, _hoisted_40)
                    ]),
                    ($setup.isLoginLoading)
                      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.loginErrorText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($setup.statusCode != 500 ? _ctx.$t('Login.UserNotFoundError') : _ctx.$t('Login.ServerError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: $setup.showLoginPage,
                      type: "link"
                    }, null, 8, ["label", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.accessRecover)
              ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('Login.RestoringAccessToAccount')), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('Login.SendContactDataMessage')), 1)
                    ]),
                    _createVNode(_component_AppTextarea, {
                      modelValue: $setup.AuthorizationProblemMessage,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.AuthorizationProblemMessage) = $event)),
                      "floating-label": _ctx.$t('Login.DescribeProblem')
                    }, null, 8, ["modelValue", "floating-label"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("img", {
                        src: $setup.iconButtonLeftLine,
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_49),
                      _createVNode(_component_AppButton, {
                        label: _ctx.$t('Login.SendResponce'),
                        disabled: $setup.isSendResponseDisabled,
                        onClick: $setup.recoverAccessInside,
                        type: "primary"
                      }, null, 8, ["label", "disabled", "onClick"]),
                      _createElementVNode("img", {
                        src: $setup.iconButtonRightLine,
                        width: "14",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_50)
                    ]),
                    ($setup.isLoginLoading)
                      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.loginErrorText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString($setup.statusCode != 500 ? $setup.loginErrorText : _ctx.$t('Login.ServerError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: $setup.showLoginPage,
                      type: "link"
                    }, null, 8, ["label", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.accessRecoverResult)
              ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('Login.RestoringAccessToAccount')), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('Login.LoginProblemNotificationDescription')), 1),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("img", {
                        src: $setup.iconButtonLeftLine,
                        width: "16",
                        height: "16",
                        class: "button-line"
                      }, null, 8, _hoisted_58),
                      _createVNode(_component_AppButton, {
                        label: _ctx.$t('Login.SendAgain'),
                        onClick: $setup.recoverAccessInside,
                        type: "primary"
                      }, null, 8, ["label", "onClick"]),
                      _createElementVNode("img", {
                        src: $setup.iconButtonRightLine,
                        width: "16",
                        height: "16",
                        class: "button-line",
                        disabled: $setup.isLoginLoading
                      }, null, 8, _hoisted_59)
                    ]),
                    ($setup.isLoginLoading)
                      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.loginErrorText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString($setup.statusCode != 500 ? $setup.loginErrorText : _ctx.$t('Login.ServerError')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_AppButton, {
                      label: _ctx.$t('Login.Back'),
                      onClick: $setup.showLoginPage,
                      type: "link"
                    }, null, 8, ["label", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}